export default __webpack_public_path__ + "static/media/figma.1cd44608.svg";